<template>
    <v-dialog
        :value="dialog"
        @keydown.esc="close"
        @click:outside="close"
        persistent
        fullscreen
        transition="dialog-bottom-transition"
    >
        <v-card class="d-flex flex-column">
            <v-card-title class="headline grey darken-3 white--text">
                <v-icon color="secondary" left>mdi-image-edit</v-icon>Editor de fotos
                <v-progress-circular
                    v-if="loadingImages.some((l) => l) && !!this.loadedImages.length"
                    :size="25"
                    :width="2"
                    color="primary"
                    class="mx-2"
                    indeterminate
                ></v-progress-circular>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :loading="savingPictures"
                            v-on="on"
                            v-bind="attrs"
                            color="white"
                            icon
                            @click="close"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-card-title>

            <v-container fluid class="pt-2 container-editor fill-height align-start">
                <v-row justify="center">
                    <v-col class="grey lighten-3 pa-0" cols="4" md="2">
                        <v-toolbar dark dense class="grey darken-3 elevation-0">
                            <v-toolbar-title class="title">Imagenes cargadas</v-toolbar-title>
                        </v-toolbar>
                        <div class="image-column overflow-y-auto">
                            <div
                                v-for="(img, index) in toEditImages"
                                :key="index"
                                class="image-container"
                                @click="toEditImage(index)"
                            >
                                <v-btn
                                    absolute
                                    top
                                    right
                                    x-small
                                    class="red white--text ma-n3"
                                    icon
                                    @click.stop="removeImg(index)"
                                >
                                    <v-icon small>mdi-close</v-icon>
                                </v-btn>
                                <img
                                    class="image"
                                    :src="img.src"
                                    @load="alreadyLoadedImg(index)"
                                />
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="8" md="10" class="pa-0">
                        <KEditPhoto :imageToEdit="imageToEdit" @saveImage="saveImage" />
                    </v-col>
                </v-row>
            </v-container>
            <v-card-actions class="justify-end d-flex">
                <v-select
                    v-if="fileTypeCodename === 'PROCPHO'"
                    class="mr-2"
                    style="max-width: 480px;"
                    label="Seguimiento/Queja"
                    :items="catalogs.followUps"
                    v-bind="FIELDS_PROPS"
                    multiple
                    small-chips
                    item-text="folio"
                    item-value="id"
                    v-model="payload.followUps"
                />
                <v-btn
                    :loading="savingPictures"
                    color="green white--text"
                    @click="sendImages"
                >Terminar edición de fotos</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Photo Editor Index
 * @author José Luis Ruiz <jose.ruiz@jbge.com.mx>
 */
import KEditPhoto from './KEditPhoto.vue'
import { FIELDS_PROPS } from '../utils'
import { reduceImageQuality, writeImage } from '@/utils'

const DEFAULT_PAYLOAD = () => ({ followUps: [ ] })
export default {
  components: {
    KEditPhoto
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: () => false
    },
    fileType: {
      type: Object,
      required: false,
      default: () => ({
        linkFollowUp: false
      })
    },
    loadedImages: {
      type: Array,
      required: true,
      default: () => []
    },
    savingPictures: {
      type: Boolean,
      required: false,
      default: false
    },
    catalogs: {
      type: Object,
      required: false,
      default: () => ({
        followUps: []
      })
    }
  },
  data() {
    return {
      imageToEdit: {},
      loadingImages: [true],
      toEditImages: [],
      indexImage: null,
      payload: DEFAULT_PAYLOAD(),
      FIELDS_PROPS
    }
  },
  computed: {
    fileTypeCodename() {
      const { toEditImages = [] } = this
      return toEditImages.length ? toEditImages[0].codename : ''
    }
  },
  methods: {
    close() {
      this.$emit('closeDialog', this.toEditImages)
    },
    removeImg(index) {
      if (index === this.indexImage) {
        this.imageToEdit = {}
      }
      this.toEditImages.splice(index, 1)
    },
    toEditImage(index) {
      this.imageToEdit = this.toEditImages[index]
      this.indexImage = index
    },
    saveImage(image) {
      reduceImageQuality(image).then((img) => {
        this.toEditImages[this.indexImage].src = img
      })
    },
    sendImages() {
      Promise.all(
        this.toEditImages.map((p) =>
          writeImage(p.src).then((res) => {
            return {
              ...p,
              file: res,
              followUps: this.payload.followUps
            }
          })
        )
      ).then((res) => {
        this.$emit('sendImages', res)
      })
    },
    alreadyLoadedImg(index) {
      this.loadingImages.splice(index, 1, false)
    }
  },
  watch: {
    loadedImages(newVal) {
      if (newVal && newVal.length) {
        this.imageToEdit = newVal[0]
        this.indexImage = 0
        this.toEditImages = [...newVal]
        this.loadingImages = newVal.map(() => true)
      } else {
        this.imageToEdit = {}
        this.indexImage = null
        this.toEditImages = []
        this.loadingImages = []
      }
    },
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.payload = DEFAULT_PAYLOAD()
        })
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="css" scoped>
.image-column {
  width: 100%;
  height: 100%;
  max-height: 80vh;
  position: relative;
  cursor: pointer;
}
.image-container {
  width: 100%;
  position: relative;
  cursor: pointer;
}
.image {
  width: 100%;
}
.container-editor {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}
</style>
